import { Col, List, Row, Spin } from 'antd';
import ActivityListItem from '../_ActivityListItem/ActivityListItem';
import { StyledStudentTaskDetailContent } from './StudentTaskDetailContent.styled';
import useStudentTaskDetailContent from './useStudentTaskDetailContent.hook';
import getDefaultLevel from 'src/modules/tasks/getDefaultLevel';

export default function StudentTaskDetailContent({ task, isPreview }) {
  const { state } = useStudentTaskDetailContent({ task });
  return (
    <StyledStudentTaskDetailContent>
      <div className="width-wrapper">
        <Spin spinning={state.loading}>
          {state.task && (
            <>
              <Row>
                <Col span={24}>
                  <h1>{state.task.name}</h1>
                </Col>
              </Row>
              <Row>
                <Col span={24} className="mt">
                  <List
                    itemLayout="vertical"
                    dataSource={state.task.taskActivities}
                    size="small"
                    renderItem={(taskActivity) => (
                      <ActivityListItem
                        taskId={state.task.id}
                        taskActivity={taskActivity}
                        defaultLevel={getDefaultLevel(state.task?.class)}
                        isPreview={isPreview}
                        dueDate={state.task.dueDate}
                        timeOffset={state.timeOffset}
                      />
                    )}
                  />
                </Col>
              </Row>
            </>
          )}
        </Spin>
      </div>
    </StyledStudentTaskDetailContent>
  );
}
